import { render, staticRenderFns } from "./143.vue?vue&type=template&id=dc0bbc12&scoped=true&"
import script from "./143.vue?vue&type=script&lang=js&"
export * from "./143.vue?vue&type=script&lang=js&"
import style0 from "./143.vue?vue&type=style&index=0&id=dc0bbc12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0bbc12",
  null
  
)

export default component.exports